const About = () => {
  return (
    <aside id="about">
      <h2>About Me</h2>
      <div className="section-line"></div>

      <div className="section__container">
        <main className="section__container__desc">
          <p>
            Hi there! I’m Miguel de Leon, a full-stack Web Developer with a
            passion for Front-end and Design. I enrolled at Uplift Code Camp, a
            coding bootcamp based in the Philippines, and graduated but I am
            currently living in Italy. I aspire toward a career that will allow
            me to challenge myself through learning new technologies.
          </p>
          <p>
            When I’m not developing websites I enjoy biking, working out,
            playing the guitar, bass, or the drums.
          </p>
        </main>
      </div>
    </aside>
  );
};

export default About;
